import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import React from "react";
import LikeSvg from "../assets/images/like.svg";
import DislikeSvg from "../assets/images/dislike.svg";
import CommentSvg from "../assets/images/comment.svg";
import ForwardSvg from "../assets/images/forward.svg";
import MenuSvg from "../assets/images/menu.svg";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";
function NewsImageDesc({ preview }) {
  //   const handleDownloadPreview = () => {
  //     const previewElement = document.querySelector('.download-preview');
  //     toBlob(previewElement).then(function (blob) {
  //       saveAs(blob, `${preview.name}.png`);
  //     });
  //   };
  const head_line = "వే2న్యూస్ లో వ్యాపార ప్రకటనలు"
  const description = `ఒక తెలివైన నిర్ణయం మీ వ్యాపారాన్ని అభివృద్ధి పథంలో
  నడిపిస్తుందని మీకు తెలుసా? మీ వ్యాపారాన్ని అభివృద్ధి పథంలో
  నడిపించడానికి వే2న్యూస్ లో ప్రకటనలు ఇవ్వండి. వే2న్యూస్
  ప్రకటనలు ఎక్కువ మందికి చేరుకొని మీ వ్యాపారాన్ని మరింత మంది
  ప్రజలకు చేరుస్తాయి. మీ వ్యాపారాన్ని అభివృద్ధి పథంలోకి
  తీసుకెళ్లండి. తెలివైన నిర్ణయం తీసుకోండి. వెంటనే వ్యాపార
  ప్రకటనలు ఇవ్వడానికి ఇక్కడ క్లిక్ చేయండి.`
  let desc_length = preview?.desc_length || preview?.frequecy_cap
  return (
    <>
      <div className="download-preview">
        <CreativeNameDisplay preview={preview} />

        <div className="preview-inner">
          <div className="h-full">
            <div className="min-h-[40%]">
              <img
                src={preview?.image || `https://ads.way2news.com/uploads/1704261408148.jpg`}
                alt="adImage"
                className=" rounded-t-[24px]"
              />
            </div>
            <div className="flex flex-col justify-between min-h-[60%]">
              <div className="px-2 mt-2">
                <h5>{preview.head_line || head_line}</h5>
                <p className="text-base">
                  {(preview.description || description).slice(
                    0,
                    desc_length || 0
                  )}
                </p>
              </div>
              <div>
                <div className="px-5 text-xs mb-2">
                  <div className="d-flex gap-1 items-center">
                    <SlIcon className="text-gray-400" name="clock-4" library="lucide" />
                    <span className="text-bold">7m ago</span>
                    <span className="text-gray-400">/ 2 of 196 Stories</span>
                  </div>
                  <div className="border-gray-200 mb-2 mt-3 px-0 py-0 border-b"></div>
                  <div className="d-flex justify-between items-center my-0 px-2 py-0">
                    <div className="d-flex gap-2 items-center my-1">
                      <div className="d-flex items-center gap-[2px]">
                        <img src={LikeSvg} alt="like"></img>
                        <span className="text-gray-400">720</span>
                      </div>
                      <div className="d-flex items-center gap-[2px]">
                        <img src={DislikeSvg} alt="dislike"></img>
                        <span className="text-gray-400">18</span>
                      </div>
                      <div className="d-flex items-center gap-[2px]">
                        <img src={CommentSvg} alt="comment"></img>
                        <span className="text-gray-400">4</span>
                      </div>
                    </div>
                    <div className="d-flex gap-2 items-center my-1">
                      <img src={MenuSvg} alt="menu"></img>
                      <img src={ForwardSvg} alt="forward"></img>
                    </div>
                  </div>
                </div>
                <div>
                  <img src={preview.img_urls} className="rounded-b-[24px]" alt="adImage"></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewsImageDesc;
